import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LinkedInLoginService {

  private clientId = environment.linkedin.clientId;
  private redirectUri = environment.linkedin.redirectUri;

  constructor(private ngZone: NgZone) {}

  login(): Observable<string> {
    const subject = new Subject<string>();
    

    const scope = 'openid profile email'; 
    const state = Math.random().toString(36).substring(7);
    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&state=${state}&scope=${scope}`;

    const width = 600;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    
    const popup = window.open(
      authUrl,
      'LinkedIn Login',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
    );

    const messageListener = (event: MessageEvent) => {

      if (event.origin !== window.location.origin) return;

      if (event.data && event.data.type === 'linkedin-login-success') {
        const code = event.data.code;
        this.ngZone.run(() => {
          subject.next(code);
          subject.complete();
        });
        window.removeEventListener('message', messageListener);
        if (popup) popup.close();
      } else if (event.data && event.data.type === 'linkedin-login-error') {
        this.ngZone.run(() => {
          subject.error(new Error(event.data.message || 'LinkedIn login failed'));
        });
        window.removeEventListener('message', messageListener);
        if (popup) popup.close();
      }
    };

    window.addEventListener('message', messageListener);

    const checkClosed = setInterval(() => {
      if (popup && popup.closed) {
        clearInterval(checkClosed);
        if (!subject.closed) {
          this.ngZone.run(() => {
            subject.error(new Error('LinkedIn login window closed.'));
          });
          window.removeEventListener('message', messageListener);
        }
      }
    }, 1000);

    return subject.asObservable();
  }
}
